function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M769.508 575.25A147.008 147.008 0 00532.22 459.231a159.073 159.073 0 00-271.922 55.727 118.634 118.634 0 10-78.817 207.299c1.844 0 3.676-.048 5.5-.131 1.882.081 3.773.131 5.676.131h445.319a128.963 128.963 0 00128.35-116.487 147.587 147.587 0 003.182-30.52z",
  fill: "#ffd005"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M774.508 557.25A147.008 147.008 0 00537.22 441.231a159.073 159.073 0 00-271.922 55.727 118.634 118.634 0 10-78.817 207.299c1.844 0 3.676-.048 5.5-.131 1.882.081 3.773.131 5.676.131h445.319a128.963 128.963 0 00128.35-116.487 147.587 147.587 0 003.182-30.52z",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 192.675,
  cy: 368.803,
  r: 93.445,
  fill: "#ffd005"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 170.077,
  y: 165.056,
  width: 45.806,
  height: 92.346,
  rx: 22.903,
  fill: "#ffd005"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 465.887,
  y: 332.979,
  width: 45.806,
  height: 92.346,
  rx: 22.903,
  transform: "rotate(60 486.006 196.585)",
  fill: "#ffd005"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 192.656,
  y: 490.024,
  width: 45.806,
  height: 92.346,
  rx: 22.903,
  transform: "rotate(-120 110.154 537.805)",
  fill: "#ffd005"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 192.961,
  y: 332.45,
  width: 45.806,
  height: 92.346,
  rx: 22.903,
  transform: "rotate(-60 59.15 472.318)",
  fill: "#ffd005"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 203.675,
  cy: 357.803,
  r: 93.445,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 181.077,
  y: 154.056,
  width: 45.806,
  height: 92.346,
  rx: 22.903,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 476.887,
  y: 321.979,
  width: 45.806,
  height: 92.346,
  rx: 22.903,
  transform: "rotate(60 497.006 185.585)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 203.656,
  y: 479.024,
  width: 45.806,
  height: 92.346,
  rx: 22.903,
  transform: "rotate(-120 121.154 526.805)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 203.961,
  y: 321.45,
  width: 45.806,
  height: 92.346,
  rx: 22.903,
  transform: "rotate(-60 70.15 461.318)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M697.222 530.702l-16.092 32.801s-29.088-3.713-17.329 34.658c0 0-3.094 29.088-9.283 35.277s4.951 47.036 27.231 35.277c12.533-6.614 13.316-14.208 11.603-19.586a48.53 48.53 0 01-1.505-24.878c2.236-10.47 6.264-23.86 13.42-35.373 14.235-22.9 27.85-45.18 27.85-45.18z",
  fill: "#a0616a"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M656.994 328.942s-35.277-8.664-47.036-2.475-46.417 6.808-46.417 6.808-29.088 47.036-22.28 71.172 35.276 38.99 35.276 38.99l95.929.62 15.472-63.128s-7.426-43.322-13.615-45.798-17.33-6.189-17.33-6.189z",
  fill: "#3f3d56"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 625.43,
  cy: 112.948,
  r: 52.606,
  fill: "#2f2e41"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M592.629 158.127s6.189 25.994-3.095 29.088-17.329 15.473-17.329 15.473l13.616 22.899 46.417 11.759 14.234-13.616 10.522-29.088-10.522-7.426s-9.902 3.094-10.52-6.808a165.033 165.033 0 01.618-22.28z",
  fill: "#a0616a"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M592.629 158.127s6.189 25.994-3.095 29.088-17.329 15.473-17.329 15.473l13.616 22.899 46.417 11.759 14.234-13.616 10.522-29.088-10.522-7.426s-9.902 3.094-10.52-6.808a165.033 165.033 0 01.618-22.28z",
  opacity: 0.1
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 616.456,
  cy: 137.395,
  r: 37.753,
  fill: "#a0616a"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M614.29 223.73l-35.896-32.801s-16.091 13.615-17.948 13.615-25.993 7.427-26.612 10.522 21.042 35.896 21.042 35.896-4.951 24.136 0 34.658 1.238 55.7 1.238 55.7 32.801-11.759 50.13-6.189 68.079 0 68.079 0 7.426-47.655 4.332-53.844-3.713-41.466-3.713-41.466l26.612-29.088s-5.57-22.28-26.612-23.518-34.04-2.475-34.04-2.475z",
  fill: "#2f2e41"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M572.205 375.978s-69.316-31.563-97.166-46.417-70.554-3.094-56.939 30.326 89.74 66.222 89.74 66.222 24.756 18.566 39.61 17.948 36.205-.31 36.205-.31zM679.274 380.31s124.398 1.238 116.352 47.655-55.7 123.78-64.365 125.636-40.228-11.76-40.228-16.091 30.326-84.17 30.326-84.17l-74.268-22.9z",
  fill: "#3f3d56"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M702.792 241.678s7.427 71.173 3.713 82.313-16.71 41.466-33.42 56.32-40.228 89.74-53.225 53.843 21.042-55.7 21.042-55.7l34.121-48.006.32-78.126z",
  fill: "#a0616a"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M563.54 390.832s61.271 21.661 68.079 18.567 21.661 8.045 21.661 8.045a53.352 53.352 0 0140.228 7.427c19.805 12.997 24.137 27.85 19.805 28.469s-19.805-6.189-19.805-6.189-23.518-4.951-37.752-.619-32.787-4.801-32.787-4.801l-75.52-16.86z",
  fill: "#a0616a"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M563.54 390.832s61.271 21.661 68.079 18.567 21.661 8.045 21.661 8.045a53.352 53.352 0 0140.228 7.427c19.805 12.997 24.137 27.85 19.805 28.469s-19.805-6.189-19.805-6.189-23.518-4.951-37.752-.619-32.787-4.801-32.787-4.801l-75.52-16.86z",
  opacity: 0.1
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M533.834 268.29s.619 76.744 9.902 86.027 19.186 21.661 28.47 27.231 14.234 18.567 14.234 18.567S631 465.1 631.619 435.392s-22.9-53.225-22.9-53.225l-4.602-4.383a209.084 209.084 0 01-27.182-31.202 32.533 32.533 0 00-6.587-7.119c-8.045-6.188-9.902-74.267-9.902-74.267z",
  fill: "#a0616a"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M688.557 203.307l12.997 7.427s4.951 32.8 7.427 37.133-30.326 15.473-35.277 12.378-7.427-33.42-7.427-33.42zM541.88 214.447h-8.046s-8.665 9.283-8.046 29.088-7.427 32.182-2.476 34.039 29.648-7.971 29.368-5.223 12.717-2.204 12.717-2.204l-8.664-32.801z",
  fill: "#2f2e41"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M479.681 341.32s37.753 16.091 48.274 18.567 44.526 31.444 44.526 31.444l-23.212 35.247s-23.79-2.945-36.786-5.42-90.359-53.844-77.362-62.509 44.56-17.329 44.56-17.329z",
  opacity: 0.1
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M471.944 341.32s37.753 16.091 48.274 18.567 51.987 30.945 51.987 30.945l-20.423 39.609s-34.04-6.808-47.036-9.283-90.359-53.844-77.362-62.509 44.56-17.329 44.56-17.329z",
  fill: "#3f3d56"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 635.642,
  cy: 77.362,
  r: 52.606,
  fill: "#2f2e41"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 650.495,
  cy: 24.756,
  r: 24.756,
  fill: "#2f2e41"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  d: "M0 722.129h881"
});

var SvgWeatherApp = function SvgWeatherApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 881,
    height: 722.629,
    viewBox: "0 0 881 722.629"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

export default "data:image/svg+xml;base64,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";
export { SvgWeatherApp as ReactComponent };